module.exports = __webpack_public_path__ + "media/images/logo_transparent-9e90ca344ca5b987b5a4a361bc4e5a6d.png";